module.exports = __webpack_public_path__ + "img/240.de1a40bb.jpg";